// extracted by mini-css-extract-plugin
export default {"colList":"AboutUs_colList__hnVs7","col":"AboutUs_col__d05xE","box":"AboutUs_box__YwxTB","iconBox":"AboutUs_iconBox__p9ITi","title":"AboutUs_title__2qBjI"};